import React from 'react';
import { Badge } from 'react-bootstrap';
import {
  FaMoneyBillWave, FaFileAlt, FaAlignLeft
} from 'react-icons/fa';
import GenericCrudPage from '../components/GenericCrudPage';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const validateFeeTypeForm = (form) => {
  const errors = {};
  if (!form.feeName.trim()) errors.feeName = "Fee name is required";
  if (form.feeName.length > 100) errors.feeName = "Fee name must be less than 100 characters";
  return errors;
};

const feeTypeConfig = {
  baseUrl: BASE_URL,
  endpoints: {
    fetch: '/master/getFeeType',
    save: '/master/saveFeeType',
    update: '/master/updateFeeType',
    delete: '/master/deleteFeeType'
  },
  validateForm: validateFeeTypeForm,
  initialFormState: {
    feeName: "",
    description: "",
    isActive: 1,
    user: ""
  },
  entityName: 'Fee Type'
};

const formFields = [
  { name: "feeName", label: "Fee Type Name", icon: FaMoneyBillWave, required: true },
  { name: "description", label: "Description", icon: FaAlignLeft, as: "textarea", rows: 3 }
];

const tableColumns = [
  {
    key: 'exFeeName',
    label: 'Fee Type Name',
    sortable: true,
    render: (feeType) => (
      <div>
        <div className="fw-bold">{feeType.exFeeName}</div>
        <div className="text-muted small">{feeType.exDescription || 'No description'}</div>
      </div>
    )
  }
];

const csvHeaders = [
  { key: 'exFeeName', label: 'Fee Type Name' },
  { key: 'exDescription', label: 'Description' },
  { key: 'exIsActive', label: 'Status' }
];

const transformPayload = (form, editId, userId) => ({
  exFeeName: form.feeName.trim(),
  exDescription: form.description.trim(),
  exIsActive: form.isActive,
  user: form.user.trim() || userId,
  ...(editId && { id: editId })
});

const transformToForm = (feeType) => ({
  feeName: feeType.exFeeName || "",
  description: feeType.exDescription || "",
  isActive: feeType.exIsActive ? 1 : 0,
  user: feeType.user || ""
});

const getViewFields = (feeType) => {
  if (!feeType) return [];
  return [
    { label: "Fee Type Name", value: feeType.exFeeName, icon: FaMoneyBillWave },
    { label: "Description", value: feeType.exDescription, icon: FaAlignLeft, fullWidth: true },
    { 
      label: "Status", 
      value: feeType.exIsActive ? "Active" : "Inactive", 
      icon: FaFileAlt,
      badge: feeType.exIsActive ? "success" : "secondary"
    }
  ];
};

export default function FeeTypePage() {
  return (
    <GenericCrudPage
      title="Fee Types"
      config={feeTypeConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      emptyIcon={FaMoneyBillWave}
      searchPlaceholder="Search by fee type name or description..."
      csvHeaders={csvHeaders}
      csvFilename="fee_types_export.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
    />
  );
}